module.exports = __webpack_public_path__ + "static/corgistickers-a10382a7f59a0dcf3043d43dc9851162.png";